var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimpleArrow = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.48 14.14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.48 12.73 2.83 7.07l5.65-5.65L7.07 0 0 7.07l7.07 7.07z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimpleArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/simple-arrow.9980aa3486b199326648179769907762.svg";